import { render, staticRenderFns } from "./RfBreadcrumbButton.component.vue?vue&type=template&id=2b625b8b&scoped=true&"
import script from "./RfBreadcrumbButton.component.vue?vue&type=script&lang=js&"
export * from "./RfBreadcrumbButton.component.vue?vue&type=script&lang=js&"
import style0 from "./RfBreadcrumbButton.component.vue?vue&type=style&index=0&id=2b625b8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b625b8b",
  null
  
)

export default component.exports